export const BUILD_VERSION = '1774378423';
